<template>
    <div class="form-container">
        <loader :trigger="loading" :message="loaderMessage"></loader>
        <message></message>
        <div>
            <h1
                class="title"
                style="
                    text-align: center;
                    margin-bottom: 50px;
                    margin-top: 20px;
                    color: #4952ff !important;
                "
            >
                {{ $t("Checkout") }}
            </h1>
            <img
                style="height: 300px; width: 100%"
                src="@/assets/images/Checkout.svg"
            />
        </div>
        <div class="columns is-desktop">
            <div class="column right-border">
                <div class="pricing">
                    <p class="section-title">{{ $t("Total Shipment Cost") }}</p>
                    <div class="item total-item no-border">
                        <div class="total-container">
                            <p class="total-price">
                                <span>
                                    {{ service.price | currency("") }}
                                </span>

                                <sub style="text-transform: uppercase">
                                    {{ $t("SAR") }}
                                </sub>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="column">
                <div class="cards">
                    <p class="section-title">{{ $t("Payment") }}</p>
                    <div class="payment-tabs">
                        <comp-loader v-if="!accessTabs" />
                        <b-tabs
                            @input="changeActiveTab"
                            position="is-centered"
                            class="block"
                        >
                            <template>
                                <b-tab-item class="creditCard">
                                    <template #header>
                                        <div class="pay-options">
                                            <div
                                                class="payment-opt active"
                                                @click="getCheckoutId(false)"
                                            >
                                                <img
                                                    src="@/assets/images/mada-trs.png"
                                                />
                                            </div>
                                        </div>
                                    </template>

                                    <div>
                                        <div
                                            class="mada"
                                            v-if="paymentOpt == false"
                                        >
                                            <form
                                                id="mada"
                                                :action="
                                                    domain + '/transaction'
                                                "
                                                class="paymentWidgets"
                                                data-brands="MADA"
                                            ></form>
                                        </div>
                                    </div>
                                </b-tab-item>
                                <b-tab-item class="creditCard">
                                    <template #header>
                                        <div class="pay-options">
                                            <div
                                                class="payment-opt"
                                                @click="getCheckoutId(true)"
                                            >
                                                <img
                                                    style="height: 15px"
                                                    src="@/assets/images/visa.png"
                                                />
                                                <img
                                                    src="@/assets/images/mastercard.png"
                                                />
                                            </div>
                                        </div>
                                    </template>
                                    <div>
                                        <div
                                            class="visa"
                                            v-if="paymentOpt == true"
                                        >
                                            <form
                                                id="visa"
                                                :action="
                                                    domain + '/transaction'
                                                "
                                                class="paymentWidgets"
                                                data-brands="VISA MASTER"
                                            ></form>
                                        </div>
                                    </div>
                                </b-tab-item>
                            </template>
                            <b-tab-item>
                                <template #header>
                                    <div class="pay-options">
                                        <div class="payment-opt active">
                                            <img
                                                src="@/assets/images/logo.png"
                                            />
                                        </div>
                                    </div>
                                </template>
                                <div
                                    v-if="!showTransactionMsg"
                                    class="baredex-credit"
                                >
                                    <div style="text-align: left">
                                        <img
                                            width="80px"
                                            src="@/assets/images/logo.png"
                                        />
                                    </div>
                                    <div
                                        style="
                                            height: 150px;
                                            text-align: center;
                                        "
                                    >
                                        <p class="credits">
                                            {{
                                                userData.balance | currency("")
                                            }}
                                        </p>
                                        <p
                                            style="
                                                text-align: left;
                                                margin-top: -20px;
                                            "
                                        >
                                            <sub>{{ $t("SAR") }}</sub>
                                        </p>
                                    </div>

                                    <div
                                        v-if="checkBalance"
                                        class="addCredit"
                                        style="text-align: center !important"
                                    >
                                        <p>
                                            {{
                                                $t(
                                                    "Your don't have enough credit"
                                                )
                                            }}
                                        </p>
                                        <router-link to="/add-credit">{{
                                            $t(
                                                "Save transaction, And add credit"
                                            )
                                        }}</router-link>
                                    </div>
                                </div>
                                <div class="msg" v-if="showTransactionMsg">
                                    <img
                                        src="@/assets/images/success-checkout.svg"
                                    />
                                    <h5 class="title">
                                        {{ $t("Payment done successful") }}
                                    </h5>
                                    <p>
                                        {{
                                            $t(
                                                "We will redirect you to your shipments after 5 sec"
                                            )
                                        }}
                                    </p>
                                </div>
                            </b-tab-item>
                        </b-tabs>
                    </div>
                </div>
            </div>
        </div>
        <div class="options">
            <button
                class="back"
                v-if="!showTransactionMsg"
                @click="editShipment"
            >
                {{ $t("Back") }}
            </button>
            <div>
                <button
                    v-if="!showTransactionMsg"
                    @click="$router.push('/my-shipment')"
                    class="later"
                >
                    {{ $t("Save order, and pay later") }}
                </button>
                <button
                    @click="payWithCredit"
                    v-if="PayWithCreditDate && !showTransactionMsg"
                    class="Pay"
                >
                    {{ $t("Pay with Baredex credit") }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
// import {globalEvent} from '@/main'
// import CustomInput from "@/components/CustomInput.vue";
import { globalEvent } from "@/main";
import Message from "@/components/Messages.vue";
import Loader from "@/components/Loader.vue";
import compLoader from "@/components/compLoader.vue";
import { http, API } from "@/store/API";
import { downladFileMixin } from "@/components/Mixins/downloadFileMixin";

const $ = require("jquery");
window.$ = $;

export default {
    mixins: [downladFileMixin],
    components: {
        Loader,
        message: Message,
        compLoader,
        // CustomInput,
    },
    data() {
        return {
            paymentOpt: false,
            PayWithCreditDate: false,
            loading: true,
            loaderMessage: null,
            activeTab: 0,
            showTransactionMsg: false,
            scriptTag1: true,
            scriptTag2: true,
            accessTabs: false,
        };
    },
    methods: {
        getCheckoutId(option) {
            if (this.paymentOpt == option || !this.scriptTag2) return;
            this.accessTabs = false;
            document.head.removeChild(this.scriptTag1);
            document.head.removeChild(this.scriptTag2);
            this.scriptTag1 = false;
            this.scriptTag2 = false;
            this.paymentOpt = option;
            this.$store
                .dispatch("getCheckoutId", {
                    id: this.$route.params.id,
                    payment_option: option,
                })
                .then((res) => {
                    let visaOptions = `
                    var wpwlOptions = {
                            locale: '${this.$i18n.locale}',
                            onReady: function() {
                                var createRegistrationHtml = '<div class="customLabel">${this.$t(
                                    "Save payment details?"
                                )}</div><div class="customInput"><input class="visaCheckbox" type="checkbox" name="createRegistration" value="true" /></div>';
                                $('#visa.wpwl-form-card').find('.wpwl-button').before(createRegistrationHtml);
                            },
                            billingAddress: {},
                            mandatoryBillingFields: {
                                country: true,
                                state: true,
                                city: true,
                                postcode: true,
                                street1: true,
                                street2: false
                            },
                        }
                    `;

                    let madaOptions = `
                        var wpwlOptions = {
                            style:"card",
                            locale: '${this.$i18n.locale}',
                            onReady: function() {
                                var createRegistrationHtml = '<div class="customLabel">${this.$t(
                                    "Save payment details?"
                                )}</div><div class="customInput"><input class="visaCheckbox" type="checkbox" name="createRegistration" value="true" /></div>';
                                $('#mada.wpwl-form-card').find('.wpwl-button').before(createRegistrationHtml);
                            },
                        }
            `;
                    let recaptchaScript = document.createElement("script");
                    let options = document.createElement("script");
                    recaptchaScript.setAttribute(
                        "src",
                        `https://${
                            process.env.VUE_APP_NODE_ENV === "production"
                                ? ""
                                : "test."
                        }oppwa.com/v1/paymentWidgets.js?checkoutId=${
                            res.payment_details.id
                        }`
                    );

                    options.type = "text/javascript";
                    options.innerHTML = option ? visaOptions : madaOptions;
                    this.scriptTag1 = document.head.appendChild(options);
                    this.scriptTag2 =
                        document.head.appendChild(recaptchaScript);

                    setTimeout(() => {
                        this.accessTabs = true;
                    }, 4000);
                });
        },
        changeActiveTab(e) {
            this.activeTab = e;
        },
        editShipment() {
            this.loading = true;
            this.$store
                .dispatch(
                    "restoreShipment",
                    this.$store.state.shipment.shipment_id
                )
                .then((res) => {
                    this.loading = false;
                    this.$router.push("/send-shipment");
                });
        },
        handleMoney(money) {
            if (this.from.country != "United States") return money;
            return money / 3.75;
        },
        checkFees(val) {
            let avg = 1000;
            if (this.$store.getters.getReason == "Gift") {
                avg = 3000;
            }

            if (this.$store.state.contents[0].currency == "USD") {
                val = val * 3.75;
            }
            if (Number(val) < Number(avg)) {
                this.VATFees =
                    (Number(val) + Number(this.service.price)) * 0.15;

                this.sauidiFees = 0;
                return;
            }
            this.sauidiFees = (Number(val) + Number(this.service.price)) * 0.05;
            this.VATFees = (Number(val) + Number(this.service.price)) * 0.15;
        },
        async payWithCredit() {
            this.accessTabs = false;
            this.$store
                .dispatch("payWithCredit", this.$route.params.id)
                .then(async (res) => {
                    this.showTransactionMsg = true;
                    let shipmentId = sessionStorage.getItem("shipmentId");
                    let shipmentIdentifier =
                        sessionStorage.getItem("shipmentIdentifier");
                    await this.downloadPdfFile(
                        shipmentIdentifier,
                        shipmentId,
                        API.generateWayBill
                    );
                    setTimeout(() => {
                        this.$router.push("/my-shipment");
                    }, 4000);
                })
                .catch((err) => {
                    this.accessTabs = true;
                });
        },
        decideWeight(l, w, h, q, wt) {
            let computedWeight = (l * w * h) / 5000;
            if (computedWeight > wt) {
                return computedWeight * q;
            } else {
                return wt * q;
            }
        },
    },
    computed: {
        environment() {
            return process.env.VUE_APP_NODE_ENV;
        },
        checkBalance() {
            let total =
                this.service.price +
                this.rateDetails.oversizeFee +
                this.rateDetails.overweightFee;

            if (this.insurance) {
                if (total + 93.75 > this.balance) return true;
                return false;
            }
            if (total > this.balance) return true;
            return false;
        },
        reason() {
            return this.$store.getters.getReason;
        },
        domestic_rate() {
            return this.$store.getters.getDomesticRate;
        },
        domain() {
            return window.location.origin;
        },
        userData() {
            return this.$store.getters.userData;
        },
        balance() {
            return this.$store.state.userData.balance;
        },
        rateDetails() {
            let details = this.$store.state.service;
            let shipment = this.$store.state.shipment;
            let insured = this.$store.state.shipment.insured;
            let overweightFee = shipment.packages.reduce((a, b) => {
                if (
                    (b.measurement == "metric" && b.weight > 65) ||
                    (b.measurement == "imperial" && b.weight > 143)
                ) {
                    a += 350 * b.quantity;
                }
                return a;
            }, 0);
            let oversizeFee = shipment.packages.reduce((a, b) => {
                if (
                    (b.measurement == "metric" &&
                        (b.length > 104 || b.width > 104 || b.height > 104)) ||
                    (b.measurement == "imperial" &&
                        (b.length > 41 || b.width > 41 || b.height > 41))
                ) {
                    a += 350 * b.quantity;
                }
                return a;
            }, 0);
            return {
                currency: details.currency,
                shipping_cost: details.charge,
                discount: details.save_amount,
                insurance: insured ? 25 * details.currency : 0,
                rateCharge: details.charge,
                final_cost: insured
                    ? details.charge + 25 * details.currency
                    : details.charge,
                overweightFee: overweightFee,
                oversizeFee: oversizeFee,
            };
        },
        service() {
            return this.$store.getters.getService;
        },
        insurance() {
            return this.$store.getters.getInsurance;
        },
        getFees() {
            return this.$store.getters.getFees;
        },
        packages() {
            let p = [];
            this.$store.state.shipment.packages.forEach((pack) => {
                p.push({
                    type: pack.type,
                    weight: `${pack.weight}kg`,
                    dimensions: `${pack.length}x${pack.width}x${pack.height}`,
                    quantity: pack.quantity,
                    final_weight: `${this.decideWeight(
                        pack.length,
                        pack.width,
                        pack.height,
                        pack.quantity,
                        pack.weight
                    )}kg`,
                });
            });
            return p;
        },
        from() {
            return this.$store.getters.shipment.sendFrom;
        },
        to() {
            return this.$store.getters.shipment.sendTo;
        },
    },
    created() {
        this.$store.dispatch("userData");
        let totalPrice = this.$store.state.contents.reduce((total, curr) => {
            return total + curr.unit_price * curr.quantity;
        }, 0);
        this.checkFees(totalPrice);
        this.$store.dispatch("SAVE_FEES", {
            sauidiFees: this.sauidiFees,
            VATFees: this.VATFees,
        });

        this.$store
            .dispatch("check_credit", this.$route.params.id)
            .then((res) => {
                this.PayWithCreditDate = res;
            })
            .catch((error) => {
                this.loaderMessage = "please reload page again";
            })
            .finally(() => {
                this.loading = false;
            });
    },
    mounted() {
        this.$store
            .dispatch("getCheckoutId", {
                id: this.$route.params.id,
                payment_option: false,
            })
            .then((res) => {
                sessionStorage.setItem("shipmentId", res.order_id);
                this.$store
                    .dispatch("orderDetails", res.order_id)
                    .then((res) => {
                        sessionStorage.setItem(
                            "shipmentIdentifier",
                            res.identifier
                        );
                    });

                let recaptchaScript = document.createElement("script");
                let options = document.createElement("script");
                recaptchaScript.setAttribute(
                    "src",
                    `https://${
                        process.env.VUE_APP_NODE_ENV === "production"
                            ? ""
                            : "test."
                    }oppwa.com/v1/paymentWidgets.js?checkoutId=${
                        res.payment_details.id
                    }`
                );

                options.type = "text/javascript";
                options.innerHTML = `
                        var wpwlOptions = {
                            locale: '${this.$i18n.locale}',
                            onReady: function() {
                                var createRegistrationHtml = '<div class="customLabel">${this.$t(
                                    "Save payment details?"
                                )}</div><div class="customInput"><input class="visaCheckbox" type="checkbox" name="createRegistration" value="true" /></div>';
                                $('#mada.wpwl-form-card').find('.wpwl-button').before(createRegistrationHtml);
                            }   
                        }`;
                this.scriptTag1 = document.head.appendChild(options);
                this.scriptTag2 = document.head.appendChild(recaptchaScript);

                setTimeout(() => {
                    this.accessTabs = true;
                }, 4000);
            })
            .catch((error) => {
                this.getCheckoutId();
            });
    },
};
</script>

<style lang="scss" scoped>
.options {
    padding: 0;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;

    button {
        min-width: 100px;
        padding: 0 20px;
        height: 30px;
        line-height: 30px;
        border-radius: 5px;
        margin-top: 30px;
        cursor: pointer;

        border: none;

        &.later,
        &.back {
            margin: 0 15px;
        }

        &.Pay {
            background: #4952ff;
            color: white;
        }
    }
}

.msg {
    width: 100%;
    background: #f7f7f7;
    border-radius: 10px;
    padding: 30px 10px;
    margin: 10px 0;
    text-align: center;

    .title {
        color: #777 !important;
    }

    img {
        height: 100px;
    }
}

::v-deep {
    .payment-tabs {
        position: relative;
    }
    .cards .payment-tabs .b-tabs {
        width: 100%;
    }
    .mada .wpwl-form-card {
        background-image: linear-gradient(
            315deg,
            #dfa375 0%,
            #c58e7f 74%
        ) !important;
        background-color: #c58e7f !important;
        box-shadow: 1px 1px 4px 0px #777 !important;
        border: none !important;

        input[type="text"],
        input[type="number"],
        input[type="tel"],
        iframe.wpwl-control.wpwl-control-iframe.wpwl-control-cardNumber,
        iframe.wpwl-control.wpwl-control-iframe.wpwl-control-cvv,
        select {
            &:lang(ar) {
                direction: ltr !important;

                &::placeholder {
                    direction: rtl;
                }
            }
        }

        button.wpwl-button.wpwl-button-pay {
            background: #4952ff !important;
            margin-top: 20px;
            width: 100px;
            height: 30px;
            line-height: 30px;
            font-size: 16px;
            padding: 0;
            border: none;
            color: white;
            border-radius: 5px;
        }
    }
    .visa form.wpwl-form.wpwl-form-card.wpwl-clearfix {
        background: none;
        border: none;
        box-shadow: none;

        input[type="text"],
        input[type="number"],
        input[type="tel"],
        iframe.wpwl-control.wpwl-control-iframe.wpwl-control-cardNumber,
        iframe.wpwl-control.wpwl-control-iframe.wpwl-control-cvv,
        select {
            border: none;
            border-bottom: 2px solid #ddd;
            background: none;
            border-radius: 0;

            &:active,
            &:focus {
                border-color: #4952ff !important;
            }

            direction: ltr !important;
        }

        select.wpwl-control.wpwl-control-brand {
            border: 2px solid #ddd;
            border-radius: 5px;

            &:active,
            &:focus {
                border-color: #4952ff !important;
            }
        }

        button.wpwl-button.wpwl-button-pay {
            background: #4952ff !important;
            margin-top: 20px;
            width: 100px;
            height: 30px;
            line-height: 30px;
            font-size: 16px;
            padding: 0;
            border: none;
            color: white;
            border-radius: 5px;
        }
    }

    .tabs ul {
        border: none;
        a {
            border-bottom: none;
            position: relative;
            padding: 0;
        }
    }
}

hr {
    border-top: 4px solid #777;
    width: 89%;
    margin: 10px auto;
}

.total-container {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    justify-content: flex-end;
    align-items: center;
    flex-flow: column-reverse;
}

.total-price-SAR {
    padding: 0 20px;
    margin: 0px 10px;
    background: #efefefdd;
    font-size: 16px;
    border-radius: 50px;
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: center;
}

.right-border {
    position: relative;

    &:after {
        content: "";
        border-right: 4px solid #ddd;
        height: 50%;
        position: absolute;
        top: 11em;
        right: -10px;
    }
}

.form-container {
    background-color: white;
    box-shadow: 0 15px 15px 0 rgba(217, 217, 217, 0.3);
    border-radius: 20px;
    margin: 50px 0;
    padding: 1.5rem 1.5rem 3rem 1.5rem;
    box-sizing: inherit;
    transition: 0.4s ease-out;
    opacity: 1;
    text-transform: capitalize;

    .creditCard {
        text-align: left;
    }

    .cards,
    .pricing {
        text-align: center;
    }

    .cards {
        .baredex-credit {
            background-image: linear-gradient(315deg, #dfa375 0%, #c58e7f 74%);
            height: 5.39cm;
            width: 8.56cm;
            border-radius: 15px;
            padding: 25px 15px;
            display: inline-block;

            .credits {
                font-weight: bold;
                color: black;
                font-size: 2.4rem;
            }
        }
    }

    .pricing {
        .btn {
            width: 88%;
            border: none;
            background: #ddd;
        }

        .item {
            display: flex;
            border-bottom: 1px solid #ddd;
            width: 75%;
            margin: auto;

            sub {
                padding: 2px 5px;
            }

            &.no-border {
                border-bottom: none;
            }

            &.total-item {
                width: 88%;
                display: flex;
                align-items: center;
                justify-content: center;

                .fee-title {
                    sub {
                        font-size: 20px;
                        font-weight: bold;
                    }
                }

                .total-price {
                    white-space: nowrap;
                    width: 100%;

                    span {
                        font-size: 38px;
                        color: #000;
                        font-weight: bold;
                    }
                }
            }

            &.hashed-fee {
                width: 88%;
                padding: 5px 0 10px;

                .fee-title {
                    flex-wrap: wrap;

                    sub {
                        width: 100%;
                        text-align: left;

                        &.hint {
                            background: #efefefdd;
                            color: black;
                            font-size: 11px;
                            border-radius: 50px;
                        }
                    }
                }

                .total-price {
                    span.price {
                        opacity: 0.5;
                        display: flex;
                        justify-content: flex-end;
                        width: 100%;

                        sub {
                            font-size: 12px;
                            display: flex;
                            align-items: center;
                        }
                    }

                    sub {
                        text-align: right;

                        &.hint {
                            width: 100%;
                            background: #ff7977;
                            color: black;
                            font-size: 11px;
                            border-radius: 50px;
                        }
                    }
                }
            }

            &.total-item {
                width: 88%;

                .fee-title {
                    sub {
                        font-size: 20px;
                        font-weight: bold;
                    }
                }

                .total-price {
                    span {
                        font-size: 38px;
                        color: #000;
                        font-weight: bold;
                    }
                }
            }
        }

        .fee-title {
            width: 50%;
            display: flex;
            align-items: center;

            sub {
                font-size: 14px;
                color: #000;
            }
        }

        .total-price {
            width: 50%;
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            justify-content: flex-end;

            span {
                // font-weight: bold;
                font-size: 27px;
                color: #000;
            }
        }
    }

    .section-title {
        font-weight: bold;
        font-size: 1.4rem;
        display: inline-block;
        margin-bottom: 25px;
    }

    #form-title-top {
        margin-bottom: 25px;
        display: inline-block;
        font-weight: bold;
        font-size: 1.1em;
    }

    .step-label,
    .vertical-step {
        display: inline-block;
        height: 100px;
    }

    .vertical-step {
        position: absolute;
        width: 15px;

        div {
            position: relative;
            width: 15px;
            height: 100px;

            .circle,
            .step-line,
            .blink {
                position: absolute;
                background-color: #727cf5;
                display: inline-block;
            }

            .step-line {
                height: 80px;
                width: 2px;
                top: 10px;
                left: 8px;
            }

            .circle {
                height: 8px;
                width: 8px;
                border-radius: 50%;
                left: 1px;
                border: 0.25em solid #fafbfe;
                box-sizing: content-box;
                z-index: 5;
            }

            .circle:first-child {
                top: 4px;
            }

            .circle:last-child {
                bottom: 5px;
            }

            .blink {
                animation-name: blink;
                animation-iteration-count: infinite;
                animation-duration: 2s;
                animation-timing-function: ease-out;
                border-radius: 50%;
                width: 32px;
                height: 32px;
                bottom: -19px;
                left: 9px;
                z-index: 6;
            }
        }
    }

    .step-label {
        position: relative;
        min-width: 50px;

        p {
            display: inline-block;
            position: absolute;
        }

        p:first-child {
            top: 0;
        }

        p:last-child {
            bottom: 0;
        }

        &:first-child {
            min-width: 50px;
        }

        &:last-child {
            min-width: 200px;
            margin-left: 28px;
        }
    }
}

.hide-form-container {
    opacity: 0;
}

.addCredit {
    padding: 7px 11px;
    margin: 30px 10px;
    font-size: 14px;
    background: #efefefdd;
    font-size: 16px;
    border-radius: 50px;
    font-weight: bold;
    text-align: center !important;

    a {
        margin: 0 10px;
        text-decoration: underline;
    }
}

.pay-options {
    display: flex;
    margin-bottom: 10px;
    .payment-opt {
        margin: 5px;
        cursor: pointer;
        display: flex;
        align-items: center;
        border: 1px solid #ddd;
        background: white;
        border-radius: 5px;
        padding: 10px 30px;
        img {
            height: 20px;
            -webkit-filter: grayscale(100%); /* Safari 6.0 - 9.0 */
            filter: grayscale(100%);
            opacity: 0.65;
        }
    }
}

.is-active {
    img {
        -webkit-filter: grayscale(0%) !important; /* Safari 6.0 - 9.0 */
        filter: grayscale(0%) !important;
        opacity: 1 !important;
    }
}

// .form-msg {
//     text-align: center;
//     font-size: 30px;
//     margin-top: 70px;
//     color: #777;
// }

@keyframes blink {
    0% {
        transform: translate(-50%, -50%) scale(0);
        opacity: 1;
    }

    100% {
        transform: translate(-50%, -50%) scale(1);
        opacity: 0;
    }
}

@media screen and (max-width: 700px) {
    .form-container {
        padding: 30px 0 !important;
    }

    .item {
        width: 90% !important;
    }
}
</style>
